import {
  ProjectSkillAssociationFragment,
  SkillFragment,
} from '../../../../__generated__/graphql';
import {
  EmployeeSkillAssociation,
  isSkillLevel,
  Skill,
  SkillLevel,
} from '../../../Skills/common/types';
import {
  mapCategoryRef,
  mapSkillTranslations,
} from '../../../Skills/common/mappings';

export const mapProjectSkillAssociation = (
  src: ProjectSkillAssociationFragment,
): EmployeeSkillAssociation => ({
  id: src.Id,
  skillId: src.skill.Id,
  isRateable: src.skill.flair__Rateable__c,
  employeeId: src.flair__Project__c,
  name: src.skill.localizedName,
  baseName: src.skill.Name,
  translations: mapSkillTranslations(src.skill),
  isTop: src.flair__Top__c,
  level: isSkillLevel(src.flair__Rate__c) ? src.flair__Rate__c : null,
  monthsExperience: src.flair__Months_Experience__c ?? null,
  selfServiceMode: src.skill.flair__Self_Service_Mode__c ?? null,
  category: mapCategoryRef(src.skill.category),
});

export const mapAvailableProjectSkills = (
  allSkills: readonly SkillFragment[],
  assigned: readonly ProjectSkillAssociationFragment[],
): Skill[] => {
  const assignedIds = new Set(assigned.map((s) => s.flair__Skill__c));
  return allSkills
    .filter((skill) => !assignedIds.has(skill.Id))
    .map(
      (src): Skill => ({
        id: src.Id,
        name: src.localizedName,
        baseName: src.Name,
        translations: mapSkillTranslations(src),
        isRateable: src.flair__Rateable__c,
        createdDate: src.CreatedDate,
        selfServiceMode: src.flair__Self_Service_Mode__c ?? null,
        category: null,
        path: null,
      }),
    );
};

export type { SkillLevel };
